const openModalButton = document.getElementById("open-modal-button-recover");
const modal = document.getElementById("modal");
const modalText = document.getElementById("modal-text");
const closeModalButton = document.getElementById("close-modal-button");
const modalOverlay = document.getElementById("modal-overlay");

// Abrir modal
openModalButton.addEventListener("click", () => {
  modal.style.display = "block";
  modalOverlay.style.display = "block";
});

// Cerrar modal
closeModalButton.addEventListener("click", () => {
  modal.style.display = "none";
  modalOverlay.style.display = "none";
});

// Cerrar modal al hacer clic fuera de ella
modalOverlay.addEventListener("click", () => {
  modal.style.display = "none";
  modalOverlay.style.display = "none";
});
